import { FirebaseProvider, useFirebase } from './components/FirebaseProvider';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ReloadPrompt } from './components/ReloadPrompt';
import { NetworkStatus } from './components/NetworkStatus';
import './index.css';

const AppContent = () => {
  const { user, loading, isInitialized } = useFirebase();

  if (!isInitialized || loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-emerald-500/20 border-t-emerald-500 rounded-full animate-spin" />
      </div>
    );
  }

  return user ? <Dashboard /> : <Login />;
};

export default function App() {
  return (
    <ErrorBoundary>
      <FirebaseProvider>
        <NetworkStatus />
        <AppContent />
        <ReloadPrompt />
      </FirebaseProvider>
    </ErrorBoundary>
  );
}
